import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicLayoutComponent {}
